import styled from 'styled-components';

export const Wrapper = styled.div`
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding-bottom: 15px;
    border-bottom: 1px solid #eee;

    h3 {
      display: flex;
      align-items: center;
      gap: 10px;
      margin: 0;
      color: #333;
    }
  }

  .content-layout {
    display: grid;
    grid-template-cols: auto 1fr;
    gap: 30px;

    @media (max-width: 768px) {
      grid-template-cols: 1fr;
    }
  }
`;

export const CalendarWrapper = styled.div`
  .react-datepicker__day--selected,
  .react-datepicker__day--keyboard-selected {
    background-color: transparent !important;
    color: #000 !important;
  }

  .react-datepicker__day--highlighted {
    background-color: #4cd964 !important;
    color: white !important;
    border-radius: 8px;
  }
  .react-datepicker__day--today {
    border: 1px solid #4cd964 !important;
  }
`;

export const SelectedDaysGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  gap: 10px;
  padding: 10px;
  background: #fcfcfc;
  border: 1px dashed #ccc;
  border-radius: 8px;
  min-height: 200px;

  .empty-state {
    color: #999;
    font-size: 14px;
    width: 100%;
    text-align: center;
    margin-top: 80px;
  }
`;

export const DayBadge = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  background: #fff3cd;
  color: #856404;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 14px;
  border: 1px solid #ffeeba;
  transition: all 0.2s;

  &:hover {
    border-color: #ffeeba;
    background: #ffeeba;
  }

  button {
    background: none;
    border: none;
    cursor: pointer;
    color: #856404;
    display: flex;
    align-items: center;
    padding: 0;

    &:hover {
      color: #721c24;
    }
  }
`;
